<template>
  <div class="dashboard-editor-container" v-loading="loading">
    <div>
      <!-- <el-button
        size="mini"
        style="
          position: absolute;
          cursor: pointer;
          user-select: auto;
          top: 10px;
        "
        type="success"
        icon="el-icon-refresh-left"
        circle
        @click="getAgencyDashboard()"
      ></el-button> -->
      <el-button
        v-show="false"
        style="cursor: pointer"
        type="success"
        :loading="loading"
        circle
        icon="el-icon-refresh-left"
        @click="getAgencyDashboard()"
      ></el-button>
    </div>
    <!-- <github-corner class="github-corner" /> -->

    <!-- <el-row
      style="
        text-align: center;
        background-color: rgb(48, 65, 86);
        padding: 5px;
      "
    >
      <el-image
        v-if="avatar"
        style="width: 10%; text-align: center"
        :src="avatar"
      ></el-image>
    </el-row> -->
    <!-- <panel-group
      @handleSetLineChartData="handleSetLineChartData"
      :perYearMemberCount="perYearMemberCount"
      :chatCount="chatCount"
      :recordRequests="recordRequests"
    /> -->

    <panel-group
      :isFree="isFree"
      :diffDays="diffDays"
      :perYearMemberCount="perYearMemberCount"
      :chatCount="chatCount"
      :recordRequests="recordRequests"
      :travelQtyByOver="travelQtyByOver"
    />

    <el-row :gutter="16" v-show="device !== 'mobile'">
      <el-col :xs="24" :sm="24" :md="24" :lg="8" style="margin-bottom: 16px">
        <div class="chart-wrapper">
          <!-- 每月出團人數 -->
          <line-chart :chart-data="lineChartData" />
        </div>
      </el-col>

      <el-col :xs="24" :sm="24" :md="24" :lg="8" style="margin-bottom: 16px">
        <div class="chart-wrapper">
          <!-- 當週出團人數 -->
          <bar-chart :weekTourists="weekTourists" />
        </div>
      </el-col>

      <el-col :xs="24" :sm="24" :md="24" :lg="8" style="margin-bottom: 16px">
        <div class="chart-wrapper" style="padding-bottom: 16px">
          <!-- 意見調查滿意度（整體平均分數）-->
          <box-card :surveyAnalysis="surveyAnalysis" />
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="16" v-show="device !== 'mobile'">
      <el-col :xs="24" :sm="24" :md="24" :lg="8" style="margin-bottom: 16px">
        <div class="chart-wrapper">
          <!-- 性質分布 -->
          <raddar-chart :travelProperties="travelProperties" :max="max" />
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="8" style="margin-bottom: 16px">
        <div class="chart-wrapper">
          <!-- 旅遊國家統計 -->
          <pie-chart :travelRegion="travelRegion" />
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="8" style="margin-bottom: 16px">
        <div class="chart-wrapper" style="padding-bottom: 16px; height: 366px">
          <!-- 意見調查滿意度 (不滿意的旅客) -->
          <not-satisfied-box-card dynamicMaxHeight="305px" />
        </div>
      </el-col>
    </el-row>

    <!-- mobile -->
    <el-row :gutter="16" v-show="device === 'mobile'">
      <el-col :xs="24" :sm="24" :md="24" :lg="8" style="margin-bottom: 16px">
        <div class="chart-wrapper" style="padding-bottom: 16px">
          <!-- 意見調查滿意度（整體平均分數）-->
          <box-card :surveyAnalysis="surveyAnalysis" />
        </div>
      </el-col>

      <el-col :xs="24" :sm="24" :md="24" :lg="8" style="margin-bottom: 16px">
        <div class="chart-wrapper" style="padding-bottom: 16px; height: 366px">
          <!-- 意見調查滿意度 (不滿意的旅客) -->
          <not-satisfied-box-card dynamicMaxHeight="305px" />
        </div>
      </el-col>

      <el-col :xs="24" :sm="24" :md="24" :lg="8" style="margin-bottom: 16px">
        <div class="chart-wrapper">
          <!-- 每月出團人數 -->
          <line-chart :chart-data="lineChartData" />
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="16" v-show="device === 'mobile'">
      <el-col :xs="24" :sm="24" :md="24" :lg="8" style="margin-bottom: 16px">
        <div class="chart-wrapper">
          <!-- 當週出團人數 -->
          <bar-chart :weekTourists="weekTourists" />
        </div>
      </el-col>

      <el-col :xs="24" :sm="24" :md="24" :lg="8" style="margin-bottom: 16px">
        <div class="chart-wrapper">
          <!-- 性質分布 -->
          <raddar-chart :travelProperties="travelProperties" :max="max" />
        </div>
      </el-col>

      <el-col :xs="24" :sm="24" :md="24" :lg="8" style="margin-bottom: 16px">
        <div class="chart-wrapper">
          <!-- 旅遊國家統計 -->
          <pie-chart :travelRegion="travelRegion" />
        </div>
      </el-col>
    </el-row>

    <!-- <el-row :gutter="8">
      <el-col
        :xs="{ span: 24 }"
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :lg="{ span: 12 }"
        :xl="{ span: 12 }"
        style="padding-right: 8px; margin-bottom: 30px"
      >
        <transaction-table />
      </el-col>
      <el-col
        :xs="{ span: 24 }"
        :sm="{ span: 12 }"
        :md="{ span: 12 }"
        :lg="{ span: 6 }"
        :xl="{ span: 6 }"
        style="margin-bottom: 30px"
      >
        <todo-list />
      </el-col>

   <el-col
        :xs="{ span: 24 }"
        :sm="{ span: 12 }"
        :md="{ span: 12 }"
        :lg="{ span: 6 }"
        :xl="{ span: 6 }"
        style="margin-bottom: 30px"
      >
        <box-card />
      </el-col>
    </el-row> -->
  </div>
</template>

<script>
import GithubCorner from '@/components/GithubCorner'
import PanelGroup from './components/PanelGroup'
import LineChart from './components/LineChart'
import RaddarChart from './components/RaddarChart'
import PieChart from './components/PieChart'
import BarChart from './components/BarChart'
// import TransactionTable from './components/TransactionTable'
import TodoList from './components/TodoList'
import BoxCard from './components/BoxCard'
import NotSatisfiedBoxCard from '@/components/CardList/NotSatisfiedBoxCard'
import { getAnAgencyAvatarByCode } from '@/api/agency'
import { getAgencyDashboard } from '@/api/travel'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'

export default {
  name: 'DashboardAdmin',
  components: {
    GithubCorner,
    PanelGroup,
    LineChart,
    RaddarChart,
    PieChart,
    BarChart,
    TodoList,
    BoxCard,
    NotSatisfiedBoxCard,
  },
  async created() {
    if (this.$store.getters.userInfo && this.$store.getters.userInfo.agencyCode) {
      let resp = await getAnAgencyAvatarByCode({
        code: this.$store.getters.userInfo.agencyCode,
      })
      this.avatar = resp.data
    }
    await this.getAgencyDashboard()
  },
  computed: {
    ...mapGetters(['device']),
  },
  data() {
    return {
      loading: false,
      avatar: '',
      lineChartData: {
        expectedData: [],
        actualData: [],
      },
      isFree: false,
      freeEndDate: null,
      diffDays: 0,
      perYearMemberCount: 0,
      chatCount: 0,
      recordRequests: 0,
      travelQtyByOver: 0,
      travelProperties: [],
      travelRegion: [],
      dashboardData: null,
      weekTourists: [],
      surveyAnalysis: [],
      max: 0,
    }
  },
  methods: {
    async getAgencyDashboard() {
      this.loading = true
      try {
        let resp = await getAgencyDashboard({
          agencyCode: this.$store.getters.userInfo.agencyCode,
        })
        this.dashboardData = resp.data
        this.lineChartData = this.dashboardData.monthToMonth
        this.isFree = this.dashboardData.agencyFreeDateInfo.isFree
        this.freeEndDate = this.dashboardData.agencyFreeDateInfo.freeEndDate
        this.diffDays = this.dashboardData.agencyFreeDateInfo.diffDays
        this.perYearMemberCount = this.dashboardData.perYearMemberCount
        this.chatCount = this.dashboardData.chatCount
        this.recordRequests = this.dashboardData.recordRequests
        this.travelQtyByOver = this.dashboardData.travelQtyByOver
        var list = []
        this.dashboardData.travelProperties.forEach(item => {
          list = list.concat(item.value)
        })
        this.max = Math.max.apply(null, list)
        this.travelProperties = this.dashboardData.travelProperties
        this.travelRegion = this.dashboardData.travelRegion
        this.weekTourists = this.dashboardData.weekTourists
        this.surveyAnalysis = this.dashboardData.surveyAnalysis
        const alertFreeEndDate = dayjs(this.freeEndDate).add(1, 'day').format('YYYY-MM-DD')
        const currentDate = dayjs().format('YYYY-MM-DD')
        if (alertFreeEndDate === currentDate) {
          this.$notify({
            title: '提示',
            message: '您的試用期間已結束',
            type: 'warning',
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-editor-container {
  padding: 15px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
  }
}

@media (max-width: 1024px) {
  .chart-wrapper {
    padding: 8px;
  }
}
</style>
